// extracted by mini-css-extract-plugin
module.exports = {"NavigationLogo":"styles_NavigationLogo__L6O0G","black-theme":"styles_black-theme__8c9Ji"};